import { useEffect, useState } from "react";

import { ITrialLicense } from "@/base/NewselaGlobalLayoutV2/NavigationBar/PremiumTrial/TrialBanner/TrialBanner.types";
import { API_BASE_URL } from "@/api/api.config";
import fetchJson from "@/remoteState/fetchJson";

const useFetchLicenses = () => {
  const [licenses, setLicenses] = useState<ITrialLicense[]>([]);

  useEffect(() => {
    const fetchLicenses = async () => {
      const licensesData = await fetchJson(
        `${API_BASE_URL}/api/v2/user/me/license/`,
      );
      setLicenses(licensesData as ITrialLicense[]);
    };
    void fetchLicenses();
  }, []);

  return licenses;
};

export { useFetchLicenses };
